import '~/js/modules/section-hero';
import 'slick-carousel';
import ReviewPanel from '~/js/components/global/reviews/ReviewPanel';

const rates = window.beaches_app.page.rates;
const $averageRate = $('#averageRate');
const $childRate = $('#childRate');
const guestReviews = document.getElementById('guest-reviews__target'); 
const $carousel = $('.js-carousel');
let childRateLowest;
let averageRateLowest;


// Initialization carousel
$carousel.slick({
    prevArrow: '<button class="rooms-prev icon-link-arrow-beaches"></button>',
    nextArrow: '<button class="rooms-next icon-link-arrow-beaches"></button>',
});

$.each(rates, (index, value) => {
    if (!childRateLowest || value[0].childRate < childRateLowest) {
        childRateLowest = value[0].childRate;
    }
    if (!averageRateLowest || value[0].averageRate < averageRateLowest) {
        averageRateLowest = value[0].averageRate;
    }
});

$childRate.html('<span>$</span>' + childRateLowest);
$averageRate.html('<span>$</span>' + averageRateLowest);

//------- View Resorts slider
//document.addEventListener(onclick, scrollContent);
//const scrollContent = (tabId) => {
//$([document.documentElement, document.body]).animate(
// {
//   scrollTop: $(".slider").offset().top - 233
// }, {
//  duration: 800,
// queue: false
//});
//};

//------ Carousel
const $resortCarousel = $('#inc-carousel');
const $control = $('#inc-carousel-control');

const $counter = $('.carousel-counter');

$resortCarousel.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
    // currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    const i = (currentSlide ? currentSlide : 0) + 1;

    $counter.text(i + '/' + slick.slideCount);
});

$resortCarousel.slick({
    appendArrows: $control,
    mobileFirst: true,
    variableWidth: true,
    centerMode: true,
    arrows: true,
    prevArrow: '<button class="icon-button-prev arrow-prev" role="button" tabindex="0" aria-label="Previous"></button>',
    nextArrow: '<button class="icon-button-next arrow-next" role="button" tabindex="0" aria-label="Next"></button>',
});
//Reviews
const urlReviews = {
  showReviews: beaches_app.page.queryParams.showReviews,
  resort: beaches_app.page.queryParams.resort
};

const resorts = beaches_app.page.resortList;
const allSliders = beaches_app.page.allSliders;
const resortsList = resorts.map(resort => {
  const slider = allSliders[(resort.code).toLowerCase()];
  const slidesTotal = slider.count;
  const slidesPath = slider.path;
  let slidesCount = 0;

  const slides = Array(slidesTotal - slidesCount + 1)
    .fill()
    .map(() => {
      slidesCount++;

      return`${slidesPath}/thumb-${slidesCount}.jpg`;

    });

  return{
    code: resort.code,
    shortName: resort.shortName,
    countryName: resort.countryName,
    city: resort.city,
    url: resort.url,
    images: slides
  };
});

ReactDOM.render(
  <ReviewPanel
    resorts={resortsList}
    urlReviews={urlReviews}
  />,
  guestReviews
);
